import { Raycaster, Plane, Vector3, Vector2 } from 'three';
import { CameraManager } from './CameraManager';

const _raycaster = new Raycaster();
const _plane = new Plane();
const _target = new Vector3();

const CameraUtilities = {
  get_plane_intersection(origin, normal, ndc) {
    const camera = CameraManager.current;
    if (!camera) return new Vector3();

    _plane.setFromNormalAndCoplanarPoint(
      normal || new Vector3(0, 1, 0),
      origin || new Vector3()
    );

    _raycaster.setFromCamera(ndc instanceof Vector2 ? ndc : new Vector2(ndc.x, ndc.y), camera);
    _raycaster.ray.intersectPlane(_plane, _target);

    return _target.clone();
  },
};

export { CameraUtilities };
